import { render, staticRenderFns } from "./FunctionalTestsDictionary.vue?vue&type=template&id=321e9a63&lang=pug&"
import script from "./FunctionalTestsDictionary.vue?vue&type=script&lang=js&"
export * from "./FunctionalTestsDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports